// import { Injectable } from '@angular/core';
// import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
// import { Observable } from 'rxjs';

// @Injectable()
// export class TokenInterceptor implements HttpInterceptor {

//   intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
//     // Obtenemos el token desde localStorage
//     const token = localStorage.getItem('token');

//     // Si el token existe, clonamos la solicitud y agregamos el header Authorization
//     if (token) {
//       request = request.clone({
//         setHeaders: {
//           Authorization: `Bearer ${token}`
//         }
//       });
//     }
    
//     return next.handle(request);
//   }
// }


import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { SpinnerService } from '../services/spinner/spinner.service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(private spinnerService: SpinnerService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Obtenemos el token desde localStorage
    const token = localStorage.getItem('token');

    // Si el token existe, clonamos la solicitud y agregamos el header Authorization
    if (token) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      });
    }
     
    // Mostramos el spinner antes de enviar la solicitud
    this.spinnerService.show();

    return next.handle(request).pipe(
      // Una vez finalizada la solicitud, se oculta el spinner
      finalize(() => this.spinnerService.hide())
    );
  }
}
